export const GET_PATIENT_INFORMATION_SUCCESS = 'filePopUp/GET_PATIENT_INFORMATION_SUCCESS'
